export default __webpack_public_path__ + "static/media/home.380011a3.svg";